/*
 * Boutique of Pashtuns — makes the main gallery's prev/next arrows
 * actually work on desktop.
 *
 * Dawn's stock gallery shows exactly one image at a time there (all
 * other slides sit at width/height 0 -- `display: none` -- until
 * <media-gallery>'s own setActiveMedia() toggles which one is
 * `.is-active`, the same way clicking a thumbnail does). Dawn's generic
 * <slider-component> prev/next click handling (assets/global.js) assumes
 * every slide has real simultaneous width so it can scroll between them;
 * since that's never true here, its own initPages()/update() silently
 * bail out, so its prev/next buttons never change the active slide or
 * update the "current/total" counter in this display mode -- clicking
 * them visibly does nothing.
 *
 * Fix: reuse the exact same <media-gallery>.setActiveMedia() method the
 * thumbnails already call successfully (assets/media-gallery.js), just
 * computing which media is next/previous instead of reading a clicked
 * thumbnail's data-target. No new active/inactive logic, no new scroll
 * handling -- this only figures out *which* media to switch to.
 */
(function () {
  function handleClick(event) {
    const button = event.target.closest('.pashtuns-main-product [id^="GalleryViewer-"] .slider-button');
    if (!button) return;

    const galleryEl = button.closest('media-gallery');
    const viewer = galleryEl ? galleryEl.querySelector('[id^="GalleryViewer-"]') : null;
    if (!galleryEl || typeof galleryEl.setActiveMedia !== 'function' || !viewer) return;

    const items = Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;

    const currentIndex = items.findIndex((item) => item.classList.contains('is-active'));
    if (currentIndex === -1) return;

    const direction = button.classList.contains('slider-button--next') ? 1 : -1;
    const nextIndex = (currentIndex + direction + items.length) % items.length;
    const nextItem = items[nextIndex];

    galleryEl.setActiveMedia(nextItem.dataset.mediaId, false);

    const counter = button.closest('.slider-buttons')?.querySelector('.slider-counter--current');
    if (counter) counter.textContent = String(nextIndex + 1);
  }

  document.addEventListener('click', handleClick);
})();
